<!-- 登录页 -->
<template>
       <div class="filmWrapTact">
        <div class="paymentLiTact">
          <div class="paymentListTact_contacklist">
            <ul>
              <li v-for="(item,index) in docslist" :key="item.id">
                <div class="listContTact">
                  <div class="listTTact L">
                     <div class="listTTact_title"><b>真实姓名</b></div>
                     <div class="listTTact_desc">{{item.realname}}</div>
                     <div class="listTTact_line"></div>
                     <div class="listTTact_title"><b>身份类型</b></div>
                     <div class="listTTact_desc">身份证</div>
                     <div class="listTTact_line"></div>
                     <div class="listTTact_title"><b>身份证号</b></div>
                     <div class="listTTact_desc">{{GetIdcardStr(item.userIdCard)}}</div>
                     <div class="listTTact_line"></div>
                                         
                 </div>
                 <div class="listWTact R">
                  <div class="truTact" @click="DelOrder(index)"><i class="iconfont iconlajixiang"></i>删除</div>
                   <Alert
                    ref="tipadds"
                    type="deletipGood"
                    title="确认删除"
                    cancleText="取消"
                    @cancle="AddTextTextFun(index)"
                    nextText="确认删除"
                    @next="delOrderFun(item.id)"
                  ></Alert>
                 </div>
                </div>

              </li>
            
     
              
            </ul>
          </div>
        </div>
       </div>
    

</template>

<script>
import Alert from "@/components/Alert";
import * as api from '@/api';
import { mapMutations } from "vuex";
export default {
  name: "filmWrapTact",
  data() {
     return {
       token:'',
       sign:'',
       docslist:'',
       id:''
      }
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    }
    this.token = this.$route.query.token;
    this.sign = this.$route.query.sign;
  },
  computed: {
   
  },
  components: {
      Alert,
  },
  mounted() {
	  this.watchUserList();
  },

  methods: {

 


// 观影人列表
    async watchUserList(){
      let _this = this;
      try{
        let testToken = 'lmojakdhkadocfaccfjocklccdfkhgoj';
        let testSign = 'dpbijiiiefibmadgopamipinnnpnphof';
        localStorage.setItem('reToken', _this.token==undefined?testToken:_this.token );
        const {code,data,message} = await api.user.watchUserList(_this.sign==undefined?testSign:_this.sign)
        console.log(code)
        if(code == '000000'){
          this.docslist = data;
          if(data!='' && data!=undefined){
            this.docslist.forEach(item => {
              try {
                this.userId = item.userId
                throw Error();
              } catch (e) {
              }   
          });
          }
          
        }else{
          // HyrToast(submsg || msg)
        }
      }catch(err){
        console.log(err)
      }
    },
    GetIdcardStr(txt){
     
     
      let str = txt;
      str = str.toString().replace(/(\w{4})\w*(\w{3})/,'$1******$2')
    

      return str;
    },
        
    DelOrder(index){
      this.$refs.tipadds[index].open();
     
    },
    AddTextTextFun(index){
     // alert('取消')
      this.$refs.tipadds[index].close();
    },
    async delOrderFun(id) {
      let _this = this;
      
      let testToken = 'lmojakdhkadocfaccfjocklccdfkhgoj';
      let testSign = 'dpbijiiiefibmadgopamipinnnpnphof';
      let info = {
        "id": id,
        "sign": _this.sign==undefined?testSign:_this.sign,
        "userid": _this.userId
      };
      localStorage.setItem('reToken', _this.token==undefined?testToken:_this.token );
      const {code,data,message} = await api.user.watchUserDel(info);
      console.log(code)
      if(code == '000000'){
        _this.watchUserList();
      }else{
        JmmToast("错误："+message);
      }
    },

    add:function(){
      let _this = this;
      let testToken = _this.token == undefined ? "lmojakdhkadocfaccfjocklccdfkhgoj" : _this.token;
      let testSign = _this.sign == undefined ? "dpbijiiiefibmadgopamipinnnpnphof" : _this.sign;
      window.location.href = "/contactlist.html#/?token="+testToken+"&sign="+testSign+"&goback=/choiceContact.html";
    },

  }
};
</script>

<style lang="stylus">
@import '../../assets/css/layout.styl'
@import '../../assets/css/common.styl'
@import '../../assets/css/icon.css'

.filmWrapTact
 background #f5f5f5
 height 100%

 .paymentLiTact
  height auto
  width 100%
  margin 0 auto
  .paymentListTact_contacklist
   li
    height 200px
    
    margin-bottom 15px
    display flex
    .listContTact
     width 100%
     height 200px
     background #fff
     margin-right 0px
     padding 30px 20px
    .listTTact
      span 
        display block
        color #d3d3d3
        font-size 22px 
        padding-top 15px
      i 
        vertical-align middle 
        font-size 22px
      em
        font-size 28px 
      b 
        font-style normal
        padding-left 20px
       
      div
        font-size 28px
        height 28px
        line-height 28px

  .listWTact
    padding-top 0px
    font-size 22px 
    color #c1bbbd
    span 
     padding-left 20px
     i
      font-size 18px
    .truTact
     i
      font-size 20px    
.loginBtnTact
    width calc(100% - 150px)calc(100% - 150px)
    height 90px
    line-height 90px
    background $background
    border-radius 45px
    font-size 34px
    text-align center
    color:$color
    cursor pointer
    position absolute
    left:0
    right 0
    bottom 40px
    margin auto
.L
  float $floLeft
.R
  float $florRight     
.checkWrapTact
  padding 0 30px 0 30px
  vertical-align middle
  align-self center
	cursor pointer
  background none


.listTTact_title{
float:left; 
width:180px;
}


.listTTact_desc{
float:left; 
width:200px;
}


.listTTact_line{
clear:both;
}

input[type="checkbox"] {
    width: 30px;
    height: 30px;
    display: inline-block;
    text-align: center;
    vertical-align: middle;
    line-height: 18px;
    margin-right: 10px;
    position: relative;
}
 
input[type="checkbox"]::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    background: #d3d3d3;
    width: 100%;
    height: 100%;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
}
 
input[type="checkbox"]:checked::before {
    content: "\2713";
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    border: 1px solid #7D7D7D;
    border-radius:4px;
    color: #7D7D7D;
    font-size: 30px;
    font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/view/contactlist/index.vue